import { render, staticRenderFns } from "./UsersHead.vue?vue&type=template&id=4c022fbf"
import script from "./UsersHead.vue?vue&type=script&lang=js"
export * from "./UsersHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports